/* eslint-disable no-use-before-define */
import _ from 'lodash';

Mobi2Go._class = Mobi2Go._class || {};

let cid = 0;
const { mixinEvents } = Mobi2Go.app;
import { isPayAtTablePlatform } from '@/legacy/api/app';
const { Price } = Mobi2Go._class.Common;

/*--------------------------------------------------------------------------
 * Constructor
 */
function Product(properties) {
    if (!(this instanceof Product)) {
        return new Product(properties);
    }
    this.init(properties);
}

Mobi2Go._class.OrderProduct = Product;

_.extend(Product.prototype, {
    /*----------------------------------------------------------------------
     * Initiate
     */
    init(properties) {
        this.id = null;

        if (!properties.menu_product) {
            throw new Error("'menu_product' required an order product");
        }
        cid += 1;
        this.cid = cid;
        mixinEvents(`OrderProduct#${this.cid}`, this);

        this.category_name = '';

        this.menu_product = null;
        this.modifier_group = null;
        this.for_name = '';
        this.comment = '';

        this.size = null;
        this.size_options = [];
        this.available_size_options = [];

        this.modifier_groups = [];
        this.visible_modifier_groups = [];
        this.hidden_modifier_groups = [];
        this.modifiers = [];
        this.modifier_credit = 0; // Amount added to total by modifiers (excluding size)
        this.modifier_credit_limit = null;
        // Amount of credit applied from modifiers with 'modifier_credit_override' enabled
        this.modifier_credit_limit_override_credit = 0;
        this.free_modifier_credit = null;

        this.display_modifiers = {
            added: [],
            removed: [],
        };
        // For comparison
        this.display_modifier_names = {
            added: [],
            removed: [],
        };

        this.quantity = 1;
        this.total_discounted = new Price(0.0);
        this.price = new Price(0.0); // Tax incl.
        this.list_price = new Price(0.0); // Tax incl. or excl.
        this.total = new Price(0.0); // Tax incl.
        this.list_total = new Price(0.0); // Tax incl. or excl.

        this.metadata = {};

        this._is_setting = false;

        this.mute = true;
        this.set(properties);
        Mobi2Go.Order.trigger('orderProductInitiated', this);
        this.mute = false;
        this.trigger('initiated');
    },

    /*----------------------------------------------------------------------
     * Set (load)
     */
    set(properties) {
        this._is_setting = true;

        if (properties.id !== undefined) {
            this.id = properties.id;
        }

        if (properties.modifier_group !== undefined) {
            this.modifier_group = properties.modifier_group;
        }

        if (properties.menu_product !== undefined) {
            if (properties.menu_product.id !== undefined) {
                this.setMenuProductById(properties.menu_product.id);
            } else if (properties.menu_product.name !== undefined) {
                this.setMenuProductByName(properties.menu_product.name);
            }
        }

        if (properties.for_name !== undefined) {
            this.setForName(properties.for_name);
        }

        if (properties.quantity !== undefined) {
            this.setQuantity(properties.quantity);
        }

        if (properties.comment !== undefined) {
            this.setComment(properties.comment);
        }

        if (properties.metadata !== undefined) {
            this.setMetadata(properties.metadata);
        }

        if (properties.modifiers !== undefined) {
            this.setModifiers(properties.modifiers);
        }

        if (properties.sub_products !== undefined) {
            this.setSubProducts(properties.sub_products);
        }

        if (properties.total_discounted !== undefined) {
            this.setTotalDiscounted(properties.total_discounted);
        }

        this._is_setting = false;

        this.calculateTotal();

        if (
            properties.price !== undefined ||
            properties.list_price !== undefined
        ) {
            this.setPrice(properties.price, properties.list_price);
        }

        if (
            properties.total !== undefined ||
            properties.list_total !== undefined
        ) {
            this.setTotal(properties.total, properties.list_total);
        }

        return this;
    },

    /*----------------------------------------------------------------------
     * MenuProduct
     */
    setMenuProductById(id) {
        const menu_product = Mobi2Go.Menu.getProducts().find({ id });
        if (!menu_product) {
            throw new Error(`Unknown product #${id}`);
        }
        return this.setMenuProduct(menu_product);
    },
    setMenuProductByName(name) {
        const menu_product = Mobi2Go.Menu.getProducts().find({
            backend_name: name,
        });
        if (!menu_product) {
            throw new Error(`Unknown product '${name}'`);
        }
        return this.setMenuProduct(menu_product);
    },
    setMenuProduct(new_menu_product) {
        if (!(new_menu_product instanceof Mobi2Go._class.MenuItem.Product)) {
            throw new TypeError(
                'menu_product must be an instance of Mobi2Go._class.MenuItem.Product'
            );
        }

        if (this.menu_product && this.menu_product.id === new_menu_product.id) {
            return this;
        }

        this.menu_product = new_menu_product;

        this.resetFreeCredit();
        this.updateModifierCreditLimit();
        loadModifiers.call(this);

        this.trigger('updateMenuProduct', this);
        this.calculateTotal();

        return this;
    },

    /*----------------------------------------------------------------------
     * For name
     */
    setForName(for_name) {
        const new_for_name = for_name ? `${for_name}`.substring(0, 35) : '';
        if (this.for_name === new_for_name) return this;

        this.for_name = new_for_name;
        this.trigger('updateForName', this.for_name);
        return this;
    },

    /*----------------------------------------------------------------------
     * Comment
     */
    setComment(comment) {
        const new_comment = comment ? `${comment}`.substring(0, 160) : '';
        if (this.comment === new_comment) return this;

        this.comment = new_comment;
        this.trigger('updateComment', this.comment);
        return this;
    },

    setMetadata(new_metadata) {
        if (_.isEqual(new_metadata, this.metadata)) {
            return this;
        }

        this.metadata = new_metadata;
        this.trigger('updateMetadata', this.metadata);

        return this;
    },

    /*----------------------------------------------------------------------
     * Quantity
     */
    setQuantity(quantity) {
        let new_quantity = +quantity;
        if (new_quantity < 1) {
            new_quantity = 1;
        }

        if (new_quantity > 2500) {
            new_quantity = 2500;
        }

        if (this.quantity === new_quantity) {
            return this;
        }
        this.quantity = new_quantity;
        this.trigger('updateQuantity', this.quantity);

        this.calculateTotal();

        return this;
    },

    /*----------------------------------------------------------------------
     * Size
     */
    getAvailableSizeOptions() {
        return this.available_size_options;
    },

    updateAvailableSizeOptions() {
        const white_list = this.getParentProductSizeWhiteList();
        let new_available_size_options;

        if (white_list) {
            new_available_size_options = this.size_options.filter(
                size_option => {
                    return (
                        _.includes(
                            white_list,
                            size_option.menu_modifier.name
                        ) ||
                        _.includes(white_list, size_option.menu_modifier.id)
                    );
                }
            );
        } else {
            new_available_size_options = this.size_options;
        }

        if (
            !_.isEqual(
                new_available_size_options.map(m => m.menu_modifier.id),
                this.available_size_options.map(m => m.menu_modifier.id)
            )
        ) {
            this.available_size_options = new_available_size_options;
            this.trigger(
                'updateAvailableSizeOptions',
                this.available_size_options
            );

            const current_size_unavailable =
                this.size &&
                !_.find(
                    this.available_size_options,
                    size => size.menu_modifier.id === this.size.menu_modifier.id
                );

            if (
                this.available_size_options.length &&
                (!this.size || current_size_unavailable)
            ) {
                this.setSize(this.available_size_options[0]);
            }
        }
    },

    setSize(size_option) {
        if (
            (!size_option && !this.size) ||
            (this.size &&
                size_option &&
                this.size.menu_modifier.id === size_option.menu_modifier.id)
        ) {
            return this;
        }

        this.size = size_option;
        this.trigger('updateSize', this.size);
        this.updateModifierCreditLimit();

        this.calculateTotal();

        return this;
    },

    setSizeByName(name) {
        _.find(this.size_options, size => {
            return size.menu_modifier.name === name && this.setSize(size);
        });

        return this;
    },

    setSizeById(id) {
        return this.setSizeByMenuId(id);
    },

    setSizeByMenuId(id) {
        _.find(this.size_options, size => {
            return size.menu_modifier.id === +id && this.setSize(size);
        });

        return this;
    },

    /*----------------------------------------------------------------------
     * Modifiers
     */

    setModifiers(modifiers_state) {
        const self = this;

        // Set size modifier
        this.setSizeFromState(modifiers_state);

        const found = {};
        // Set regular modifiers
        _.each(modifiers_state, modifier_state => {
            const modifier = findMatchingModifier(modifier_state);
            if (modifier) {
                found[modifier.menu_modifier.id] = true;
                modifier.set(modifier_state);
            }
        });
        _.each(this.modifiers, modifier => {
            if (
                (modifier.isAdded() || modifier.isRemoved()) &&
                !(modifier.menu_modifier.id in found)
            ) {
                modifier.reset();
            }
        });

        this.updateDisplayModifiers();
        this.calculateTotal();

        function compareById(modifier_state, modifier) {
            return (
                modifier_state.menu_modifier &&
                modifier_state.menu_modifier.id &&
                modifier_state.menu_modifier.id === modifier.menu_modifier.id
            );
        }

        function compareByBackendName(modifier_state, modifier) {
            return (
                modifier_state.menu_modifier &&
                modifier_state.menu_modifier.backend_name &&
                modifier_state.menu_modifier.backend_name ===
                    modifier.menu_modifier.backend_name
            );
        }

        function compareByName(modifier_state, modifier) {
            return (
                modifier_state.menu_modifier &&
                modifier_state.menu_modifier.name &&
                modifier_state.menu_modifier.name ===
                    modifier.menu_modifier.name
            );
        }
        // Search provided modifier state
        function findMatchingModifier(modifier_state) {
            let result = _.find(
                self.modifiers,
                compareById.bind(null, modifier_state)
            );
            if (result) {
                return result;
            }
            result = _.find(
                self.modifiers,
                compareByBackendName.bind(null, modifier_state)
            );
            if (result) {
                return result;
            }
            return _.find(
                self.modifiers,
                compareByName.bind(null, modifier_state)
            );
        }
    },

    setSizeFromState(modifiers_state) {
        if (!this.size_options.length) {
            return;
        }

        _.find(modifiers_state, modifier => {
            const { menu_modifier } = modifier;

            const size_option = _.find(this.size_options, size => {
                return (
                    size.menu_modifier.id === +menu_modifier.id ||
                    size.menu_modifier.name === menu_modifier.name
                );
            });

            if (size_option) {
                size_option.setId(modifier.id);
                this.setSize(size_option);

                return true;
            }

            return false;
        });
    },

    toggleModifier(modifier) {
        modifier.toggle();

        this.updateDisplayModifiers();
        this.calculateTotal(); // Move to modifier 'setTotal' event?
        return this;
    },

    toggleModifierByName(name) {
        const modifier = this.getModifierByMenuName(name);
        if (!modifier) {
            throw new Error(
                `cannot toggle unknown modifier "${_.escape(name)}"`
            );
        }
        return this.toggleModifier(modifier);
    },

    toggleModifierById(id) {
        const modifier = this.getModifierByMenuId(id);
        if (modifier === undefined) {
            throw new Error(`cannot toggle unknown modifier #${_.escape(id)}`);
        }
        return this.toggleModifier(modifier);
    },

    setModifierSelectionState(modifier, selection_state) {
        modifier.setSelectionState(selection_state);

        this.updateDisplayModifiers();
        this.calculateTotal();
        return this;
    },

    setModifierSelectionStateByName(name, selection_state) {
        const modifier = this.getModifierByMenuName(name);
        if (modifier === undefined) {
            throw new Error(
                `cannot set selection state on unknown modifier #${_.escape(
                    name
                )}`
            );
        }
        return this.setModifierSelectionState(modifier, selection_state);
    },

    setModifierSelectionStateById(id, selection_state) {
        const modifier = this.getModifierByMenuId(id);
        if (modifier === undefined) {
            throw new Error(`cannot selection state unknown modifier #${id}`);
        }
        return this.setModifierSelectionState(modifier, selection_state);
    },

    setModifierQuantity(modifier, quantity) {
        modifier.setQuantity(quantity);

        this.updateDisplayModifiers();
        this.calculateTotal();
        return this;
    },

    setModifierQuantityByName(name, quantity) {
        const modifier = this.getModifierByMenuName(name);
        if (modifier === undefined) {
            throw new Error(
                `cannot set quantity on unknown modifier #${_.escape(name)}`
            );
        }
        return this.setModifierQuantity(modifier, quantity);
    },

    setModifierQuantityById(id, quantity) {
        const modifier = this.getModifierByMenuId(id);
        if (modifier === undefined) {
            throw new Error(`cannot toggle unknown modifier #${id}`);
        }
        return this.setModifierQuantity(modifier, quantity);
    },

    getUnmetSelectionRequirementModifierGroup() {
        return _.find(this.modifier_groups, {
            selection_requirement_met: false,
        });
    },

    isInOrder(order) {
        return (order || Mobi2Go.Order).containsProduct(this);
    },

    addToOrder(order) {
        return (order || Mobi2Go.Order).addProduct(this);
    },

    removeFromOrder(order) {
        return (order || Mobi2Go.Order).removeProduct(this);
    },

    shouldQuickAddToOrder(ignore_size_requirement) {
        let has_sizes = this.size_options.length > 1;

        if (ignore_size_requirement) {
            has_sizes = false;
        }

        return (
            !has_sizes &&
            !this.getUnmetSelectionRequirementModifierGroup() &&
            !this.visible_modifier_groups.length &&
            !this.menu_product.hasTag('show-dialog')
        );
    },

    getCategoryName() {
        return this.menu_product.category
            ? this.menu_product.category.name
            : '';
    },
    setCategoryName(category_name) {
        this.category_name = category_name;
    },
});

_.extend(Product.prototype, {
    setId(new_id) {
        this.id = +new_id;
    },

    setPrice(new_price, new_list_price) {
        if (
            !this.price.isEqual(new_price) ||
            (new_list_price && !this.list_price.isEqual(new_list_price))
        ) {
            this.price.setTax(this.getTax());
            this.price.set(new_price);

            if (new_list_price) {
                this.list_price.set(new_list_price);
            } else {
                this.list_price = this.price.getListPrice();
            }

            this.trigger('updatePrice', this.price, this.list_price);
        }

        return this;
    },

    setTotal(new_total, new_list_total) {
        if (
            !this.total.isEqual(new_total) ||
            (new_list_total && !this.list_total.isEqual(new_list_total))
        ) {
            this.total.setTax(this.getTax());
            this.total.set(new_total);

            if (new_list_total) {
                this.list_total.set(new_list_total);
            } else {
                this.list_total = this.total.getListPrice();
            }

            this.trigger('updateTotal', this.total, this.list_total);

            if (this.isSubProduct()) {
                this.modifier_group.parent_product.calculateTotal();
            }
        }

        return this;
    },

    /**---------------------------------------------------------------------
     */
    getTax() {
        let location_tax;
        const product_tax = this.menu_product.tax || null;

        const location = Mobi2Go.Order.getLocation();
        if (location) {
            location_tax = location.sales_tax;
        }

        const tax = product_tax || location_tax;

        if (tax && location) {
            tax.has_tax_exclusive_prices = location.has_tax_exclusive_prices;
        }

        return tax;
    },

    /**---------------------------------------------------------------------
     */
    updateTax() {
        const tax = this.getTax();

        this.price.setTax(tax);
        this.total.setTax(tax);
    },

    /**---------------------------------------------------------------------
     */
    hasTaxExclusivePrice() {
        const sales_tax = this.getTax();

        if (sales_tax) {
            return sales_tax.has_tax_exclusive_prices;
        }
        return false;
    },

    /*----------------------------------------------------------------------
     * Adds price of size modifier
     * Calculates total price of modifier selections taking into account
     * product and modifier group free credit and product credit limit
     * and modifier credit limit overrides
     */
    calculatePrice() {
        if (isPayAtTablePlatform()) {
            this.setPrice(this.price);
        } else {
            const price = this.menu_product.getPrice();
            // Cost of modifiers (excluding size)
            let modifier_and_sub_product_total = 0;
            // Maximum amount modifiers can increase product's price by
            // incremented by any added modifiers with credit limit override
            const credit_limit = this.modifier_credit_limit;


            this.resetFreeCredit();
            this.addCreditFromRemovedModifiers();
            this.setModifierCredit(0);
            this.modifier_credit_limit_override_credit = 0;

            if (this.size) {
                price.add(this.size.getPrice());
            }

            _.each(this.modifier_groups, modifier_group => {
                modifier_group.resetFreeCredit();
                let pricing_strategy = modifier_group.menu_modifier_group.pricing_strategy;

                switch (pricing_strategy) {
                    case "SumItemsStrategy":
                        modifier_and_sub_product_total += this.getSumItemsStrategyPrice(modifier_group);
                        break;
                    case "PJIGreatestHalfAndHalf":
                    case "GreatestItemStrategy":
                        modifier_and_sub_product_total += this.getGreatestItemStrategyPrice(modifier_group);
                        break;
                    case "BOGOLesserStrategy":
                    case "CheapestItemFreeStrategy":
                        modifier_and_sub_product_total += this.getBogoLesserStrategyPrice(modifier_group);
                        break;
                    case "IgnorePluOverrideStrategy":
                    default:
                        // Note: the default should be to throw the Error below.
                        // However due to caching issues on prod, we fallback to the default "sum" strategy
                        // throw new Error("menu_modifier_group pricing strategy not found");
                        modifier_and_sub_product_total += this.getSumItemsStrategyPrice(modifier_group);
                        break;
                }
            });

            // Ensure modifier credit limit has not been exceeded if present
            if (
                credit_limit &&
                modifier_and_sub_product_total -
                    this.modifier_credit_limit_override_credit >
                    credit_limit
            ) {
                modifier_and_sub_product_total =
                    credit_limit + this.modifier_credit_limit_override_credit;
            }

            this.setModifierCredit(modifier_and_sub_product_total);
            price.add(modifier_and_sub_product_total);
            price.setTax(this.getTax());
            if (this.hasTaxExclusivePrice()) {
                price.applyTaxAmount();
            }

            if (price.toFloat() < 0) {
                price.set(0);
            }

            this.setPrice(price);
        }
    },

    getSumItemsStrategyPrice(modifier_group) {
        let modifier_price;
        let modifier_and_sub_product_total = 0;

        _.each(modifier_group.modifiers, modifier => {
            if (!modifier.isAdded()) {
                return;
            }

            modifier_price =
                modifier.price.toFloat() * modifier.quantity;

            if (!modifier.menu_modifier.ignores_free_credit) {
                modifier_price = modifier_group.applyFreeCredit(
                    modifier_price
                );
                modifier_price = this.applyFreeCredit(modifier_price);
            }

            if (modifier.hasCreditLimitOverride()) {
                this.modifier_credit_limit_override_credit += modifier_price;
            }

            modifier_and_sub_product_total += modifier_price;
        });

        _.each(modifier_group.sub_products, sub_product => {
            let sub_product_total = sub_product.total.toFloat();

            if (!sub_product.menu_product.ignores_free_credit) {
                sub_product_total = modifier_group.applyFreeCredit(
                    sub_product_total
                );
                sub_product_total = this.applyFreeCredit(
                    sub_product_total
                );
            }
            modifier_and_sub_product_total += sub_product_total;
        });
        return modifier_and_sub_product_total;
    },

    getGreatestItemStrategyPrice(modifier_group) {
        let modifier_and_sub_product_total = 0;
        let item_with_greatest_price = null;
        let greatest_price = 0;
        let total_quantity = 0;

        _.each(modifier_group.modifiers, modifier => {
            if (!modifier.isAdded()) {
                return;
            }

            total_quantity += modifier.quantity;

            if (greatest_price < modifier.price.toFloat()) {
                greatest_price = modifier.price.toFloat();
                item_with_greatest_price = modifier;
            }

            if (!modifier.menu_modifier.ignores_free_credit) {
                greatest_price = modifier_group.applyFreeCredit(
                    greatest_price
                );
                greatest_price = this.applyFreeCredit(greatest_price);
            }

            if (modifier.hasCreditLimitOverride()) {
                this.modifier_credit_limit_override_credit += greatest_price;
            }
        });

        modifier_and_sub_product_total += greatest_price * total_quantity;

        greatest_price = 0;
        total_quantity = 0;

        _.each(modifier_group.sub_products, sub_product => {
            let sub_product_total = sub_product.total.toFloat();

            total_quantity += sub_product.quantity;

            if (greatest_price < sub_product_total) {
                greatest_price = sub_product_total;
            }

            if (!sub_product.menu_product.ignores_free_credit) {
                greatest_price = modifier_group.applyFreeCredit(
                    greatest_price
                );
                greatest_price = this.applyFreeCredit(
                    greatest_price
                );
            }
        });

        modifier_and_sub_product_total += greatest_price * total_quantity;

        return modifier_and_sub_product_total;
    },

    getBogoLesserStrategyPrice(modifier_group) {
        let modifier_price;
        let modifier_and_sub_product_total = 0;

        let lowest_price;

        if (modifier_group.modifiers[0] !== undefined) {
            lowest_price = modifier_group.modifiers[0].price.toFloat();
        }

        _.each(modifier_group.modifiers, modifier => {
            if (!modifier.isAdded()) {
                return;
            }

            if (modifier.price.toFloat() < lowest_price) {
                lowest_price = modifier.price.toFloat()
            }

            modifier_price =
                modifier.price.toFloat() * modifier.quantity;

            if (!modifier.menu_modifier.ignores_free_credit) {
                modifier_price = modifier_group.applyFreeCredit(
                    modifier_price
                );
                modifier_price = this.applyFreeCredit(modifier_price);
            }

            if (modifier.hasCreditLimitOverride()) {
                this.modifier_credit_limit_override_credit += modifier_price;
            }

            modifier_and_sub_product_total += modifier_price;
        });

        if (modifier_group.modifiers.length > 1) {
            modifier_and_sub_product_total -= lowest_price;
        }

        if (modifier_group.sub_products[0] !== undefined) {
            lowest_price = modifier_group.sub_products[0].price.toFloat();
        }

        _.each(modifier_group.sub_products, sub_product => {
            let sub_product_total = sub_product.total.toFloat();

            if (sub_product_total < lowest_price) {
                lowest_price = sub_product_total
            }

            if (!sub_product.menu_product.ignores_free_credit) {
                sub_product_total = modifier_group.applyFreeCredit(
                    sub_product_total
                );
                sub_product_total = this.applyFreeCredit(
                    sub_product_total
                );
            }
            modifier_and_sub_product_total += sub_product_total;
        });

        if (modifier_group.sub_products.length > 1) {
            modifier_and_sub_product_total -= lowest_price;
        }

        return modifier_and_sub_product_total;
    },

    addCreditFromRemovedModifiers() {
        _.each(this.modifiers, modifier => {
            if (modifier.is_default && modifier.selection_state === 'off') {
                this.free_modifier_credit += modifier.price.toFloat();
            }
        });
    },

    setTotalDiscounted(total_discounted) {
        if (!this.total_discounted.isEqual(total_discounted)) {
            this.total_discounted.set(total_discounted);
            this.trigger('updateTotalDiscounted', this.total_discounted);
        }
        return this;
    },

    isFree() {
        return this.total.isEqual(this.total_discounted);
    },

    /*----------------------------------------------------------------------
     * Recalcuates product's total
     * - Multiply by product quantity
     */
    calculateTotal() {
        // Skip calculation if set() is being executed
        if (this._is_setting) {
            return;
        }
        this.calculatePrice();
        const total = this.price.toFloat() * this.quantity;

        this.setTotal(total);
    },

    /*----------------------------------------------------------------------
     * Modifier credits
     */
    resetFreeCredit() {
        this.free_modifier_credit = this.menu_product.free_modifier_credit;
    },
    applyFreeCredit(amount) {
        let new_amount = +amount;

        if (!this.free_modifier_credit) {
            return new_amount;
        }

        new_amount -= this.free_modifier_credit;
        this.free_modifier_credit -= amount;

        if (this.free_modifier_credit < 0) {
            this.free_modifier_credit = 0;
        }
        if (new_amount < 0) {
            new_amount = 0;
        }

        return new_amount;
    },
    updateModifierCreditLimit() {
        const { menu_product } = this;
        const size_credit_limit = menu_product.size_modifier_credit_limit;

        if (
            this.size &&
            size_credit_limit[this.size.menu_modifier.id] !== undefined
        ) {
            this.setModifierCreditLimit(
                size_credit_limit[this.size.menu_modifier.id]
            );
        } else {
            this.setModifierCreditLimit(menu_product.modifier_credit_limit);
        }
    },

    setModifierCreditLimit(new_credit_limit) {
        if (new_credit_limit !== this.modifier_credit_limit) {
            this.modifier_credit_limit = new_credit_limit;
            this.trigger(
                'updateModifierCreditLimit',
                this.modifier_credit_limit
            );
        }
    },

    getModifierCreditLimit() {
        return this.modifier_credit_limit;
    },

    hasModifierCreditLimit() {
        return this.modifier_credit_limit !== null;
    },

    getRemainingModifierCredit() {
        if (this.hasModifierCreditLimit()) {
            const remaining_credit =
                this.getModifierCreditLimit() +
                this.modifier_credit_limit_override_credit -
                this.getModifierCredit();

            return remaining_credit > 0 ? remaining_credit : 0;
        }

        return null;
    },

    /*----------------------------------------------------------------------
     * Modifier Groups
     */
    getModifierGroup(name) {
        let group = this.getModifierGroupByName(name);

        if (group) {
            return group;
        }

        group = this.getModifierGroupByBackendName(name);

        if (group) {
            return group;
        }

        return null;
    },
    getModifierGroupByMenuId(id) {
        return _.find(this.modifier_groups, group => {
            return group.menu_modifier_group.id === id;
        });
    },
    getModifierGroupByName(name) {
        const name_to_search = `${name}`.toLowerCase();
        return _.find(this.modifier_groups, group => {
            return (
                group.menu_modifier_group.name.toLowerCase() === name_to_search
            );
        });
    },
    getModifierGroupByBackendName(name) {
        const name_to_search = `${name}`.toLowerCase();
        return _.find(this.modifier_groups, group => {
            return (
                group.menu_modifier_group.backend_name.toLowerCase() ===
                name_to_search
            );
        });
    },

    /*----------------------------------------------------------------------
     * Modifiers
     */
    getModifier(name) {
        let modifier = this.getModifierByMenuName(name);

        if (modifier) {
            return modifier;
        }

        modifier = this.getModifierByMenuBackendName(name);

        if (modifier) {
            return modifier;
        }

        return null;
    },
    getModifierById(id) {
        return _.find(this.modifiers, { id });
    },
    getModifierByMenuId(id) {
        return _.find(this.modifiers, modifier => {
            return modifier.menu_modifier.id === id;
        });
    },
    getModifierByMenuName(name) {
        const name_to_search = `${name}`.toLowerCase();
        return _.find(this.modifiers, modifier => {
            return modifier.menu_modifier.name.toLowerCase() === name_to_search;
        });
    },
    getModifierByMenuBackendName(name) {
        const name_to_search = `${name}`.toLowerCase();
        return _.find(this.modifiers, modifier => {
            return (
                modifier.menu_modifier.backend_name.toLowerCase() ===
                name_to_search
            );
        });
    },
    getAddedModifiers() {
        return _.filter(this.modifiers, modifier => {
            return modifier.isAdded();
        });
    },
    getRemovedModifiers() {
        return _.filter(this.modifiers, modifier => {
            return modifier.isRemoved();
        });
    },
    getAlteredModifiers() {
        const modifiers = _.filter(this.modifiers, modifier => {
            return modifier.isRemoved() || modifier.isAdded();
        });

        return (this.size ? [this.size] : []).concat(modifiers);
    },

    updateDisplayModifiers() {
        const display_modifier_names = {
            added: _.invokeMap(this.getAddedModifiers(), 'toString'),
            removed: _.invokeMap(this.getRemovedModifiers(), 'toString'),
        };

        if (_.isEqual(this.display_modifier_names, display_modifier_names)) {
            return;
        }

        this.display_modifier_names = display_modifier_names;
        this.display_modifiers = {
            added: this.getAddedModifiers(),
            removed: this.getRemovedModifiers(),
        };
        this.trigger('updateDisplayModifiers', this.display_modifiers);
    },

    setModifierCredit(new_modifier_credit) {
        const modifier_credit = +new_modifier_credit;
        if (modifier_credit !== this.modifier_credit) {
            this.modifier_credit = modifier_credit;
            this.trigger('updateModifierCredit', modifier_credit);
        }
    },

    getModifierCredit() {
        return this.modifier_credit;
    },

    /*----------------------------------------------------------------------
     * OrderModifierGroup
     */
    isSubProduct() {
        return !!this.modifier_group;
    },

    setModifierGroup(modifier_group) {
        this.modifier_group = modifier_group;

        // Persistent modifier group id (temporary)
        if (modifier_group) {
            this.setMetadata({
                modifier_group_id: modifier_group.menu_modifier_group.id,
            });

            const { parent_product } = modifier_group;
            parent_product.bind('updateSize', () =>
                this.updateAvailableSizeOptions()
            );
            this.updateAvailableSizeOptions();
        }
    },

    /*----------------------------------------------------------------------
     * Subproducts
     */
    getSubProducts() {
        return this.modifier_groups.map(mg => mg.sub_products).flat();
    },

    setSubProducts(sub_products) {
        const sub_products_by_group = _.groupBy(sub_products, sub_product => {
            return sub_product.metadata.modifier_group_id;
        });

        _.each(sub_products_by_group, (mg_sub_products, modifier_group_id) => {
            const modifier_group = this.getModifierGroupByMenuId(
                +modifier_group_id
            );

            if (!modifier_group) {
                return;
            }

            modifier_group.setSubProducts(mg_sub_products);
        });
    },

    addSubProductById(menu_product_id, menu_modifier_group_id) {
        const modifier_group = this.getModifierGroupByMenuId(
            menu_modifier_group_id
        );

        if (!modifier_group) {
            throw new Error('provided `menu_modifier_group_id` not found');
        }

        const menu_product_instance = modifier_group.menu_modifier_group
            .getProducts()
            .find({ id: menu_product_id });

        if (!menu_product_instance) {
            throw new Error('provided `menu_product_id` not found');
        }

        const sub_product = menu_product_instance.createOrderProductInstance({
            modifier_group,
        });
        modifier_group.addSubProduct(sub_product);
    },

    removeFirstSubProductById(menu_product_id, menu_modifier_group_id) {
        const modifier_group = this.getModifierGroupByMenuId(
            menu_modifier_group_id
        );

        if (!modifier_group) {
            throw new Error('provided `menu_modifier_group_id` not found');
        }

        const sub_product = _.find(
            modifier_group.getSubProducts(),
            mg_sub_product => mg_sub_product.menu_product.id === menu_product_id
        );
        modifier_group.removeSubProduct(sub_product);
    },

    getModifierGroupThatContainsMenuProduct(menu_product) {
        return this.modifier_groups.find(omg => {
            return omg.menu_modifier_group.containsProduct(menu_product);
        });
    },

    getProductsWithUnmetSelectionRequirementModifierGroup() {
        return this.getSubProducts().filter(product => {
            return product.getUnmetSelectionRequirementModifierGroup();
        });
    },

    /**---------------------------------------------------------------------
     * Prices of modifiers can change if the menu tier change
     */
    updateModifierPrices() {
        _.invokeMap(this.modifiers, 'updatePrice');
    },

    getModifierSelectionCount() {
        return _.reduce(
            this.modifier_groups,
            (mem, group) => {
                if (
                    !group.menu_modifier_group
                        .product_modifier_selection_limit_override
                ) {
                    return mem + group.selection_count;
                }
                return mem;
            },
            0
        );
    },

    getParentProductSizeWhiteList() {
        const parent_product = this.modifier_group?.parent_product;
        const parent_product_size = parent_product?.size;
        const raw_size_white_list =
            parent_product_size?.menu_modifier.metadata
                .sub_product_size_whitelist;

        if (raw_size_white_list) {
            try {
                const size_white_list = JSON.parse(raw_size_white_list);
                return size_white_list;
            } catch (e) {
                return null;
            }
        }

        return null;
    },

    /*----------------------------------------------------------------------
     * Define a function that will be run whenever a product is updated.
     * This allows custom logic to be implemented
     * e.g., Hide or show particular modifiers depending on other modifier
     * state
     */
    setCustomLogic(fn) {
        const product = this;
        const runCustomLogic = _.debounce(
            function() {
                fn(product);
            },
            0,
            { leading: true, trailing: true }
        );

        runCustomLogic();

        // Decorate the trigger function to
        const { trigger } = this;
        this.trigger = function() {
            runCustomLogic();
            trigger.apply(this, arguments);
        };
    },

    /*----------------------------------------------------------------------
     * Server comms
     */
    toJson() {
        return {
            id: this.id,
            menu_product: _.pick(this.menu_product, ['id', 'name']),
            quantity: this.quantity,
            for_name: this.for_name,
            comment: this.comment,
            modifiers: _.invokeMap(this.getAlteredModifiers(), 'toJson'),
            sub_products: _.invokeMap(this.getSubProducts(), 'toJson'),
            metadata: this.metadata,
        };
    },

    /*----------------------------------------------------------------------
     * Returns a string unique to the product's state excluding the product's
     * unique ID.
     *
     * This is used when adding a product, to determine whether an identical
     * product already exists in the order so the existing product's quantity
     * can be incremented rather than adding a duplicate product instance.
     */
    getSignature() {
        return JSON.stringify([
            this.menu_product.id,
            this.for_name,
            this.comment,
            _.map(this.getAlteredModifiers(), modifier => {
                return [
                    modifier.menu_modifier.id,
                    modifier.selection_state,
                    modifier.quantity,
                ];
            }),
            _.map(this.getSubProducts(), sub_product =>
                sub_product.getSignature()
            ),
        ]);
    },

    /*----------------------------------------------------------------------
     * Modifier events
     */
    _triggerSelectionLimitWarning(modifier) {
        this.trigger('selectionLimitWarning', modifier);
    },
    _triggerUpdateModifierPrice(modifier) {
        this.trigger('updateModifierPrice', modifier);
    },
    // Called by quantity-type child modifier when quantity is updated
    _triggerUpdateModifierQuantity(modifier) {
        this.trigger('updateModifierQuantity', modifier);
    },
    _triggerUpdateModifierSelection(modifier) {
        this.trigger('updateModifierSelection', modifier);
    },
    _triggerUpdateModifierVisiblity(modifier) {
        this.trigger('updateModifierVisibility', modifier);
    },
    _triggerUpdateModifierOutOfStock(modifier) {
        this.trigger('updateModifierOutOfStock', modifier);
    },

    /*----------------------------------------------------------------------
     * Sub Product events
     */
    _triggerAddSubProduct(sub_product, modifier_group) {
        this.trigger('addSubProduct', sub_product, modifier_group);
    },
    _triggerRemoveSubProduct(sub_product, modifier_group) {
        this.trigger('removeSubProduct', sub_product, modifier_group);
    },

    /*----------------------------------------------------------------------
     * Modifier group events
     */
    _triggerUpdateGroupVisiblity(group) {
        this.trigger('updateModifierGroupVisibility', group);
    },
    _triggerUpdateGroupCollapsed(group) {
        this.trigger('updateModifierGroupCollapsed', group);
    },
    _triggerUpdateGroupSelectionLimit(group) {
        this.trigger('updateModifierGroupSelectionLimit', group);
    },
    _triggerUpdateGroupSelectionRequirement(group) {
        this.trigger('updateModifierGroupSelectionRequirement', group);
    },
    _triggerGroupSelectionLimitWarning(modifier_group, modifier) {
        this.trigger('groupSelectionLimitWarning', modifier_group, modifier);
    },
    _triggerUpdateGroupSelectionCount(modifier_group) {
        this.trigger('updateGroupSelectionCount', modifier_group);
    },
    _triggerUpdateGroupSelectionRequirementMet(modifier_group) {
        this.trigger('updateGroupSelectionRequirementMet', modifier_group);
    },
    _triggerUpdateGroupSelectionLimitMet(modifier_group) {
        this.trigger('updateGroupSelectionLimitMet', modifier_group);
    },
    _triggerUpdateGroupRestriction(group) {
        this.trigger('updateModifierGroupRestriction', group);
    },
});

Product.prototype.toString = function toString() {
    let { name } = this.menu_product;
    if (this.quantity > 1) {
        name = `${this.quantity}× ${name}`;
    }

    return name;
};

/*--------------------------------------------------------------------------
 * Creates child ModifierGroup and Modifier objects
 */
function loadModifiers() {
    const { menu_product } = this;
    const modifier_groups = menu_product.getNonSizeModifierGroups();
    const OrderModifierGroup = Mobi2Go._class.OrderProductModifierGroup;

    if (this.modifiers.length) {
        _.invokeMap(this.modifiers, 'unbindFromProduct');
    }

    this.modifier_groups = [];
    this.visible_modifier_groups = [];
    this.hidden_modifier_groups = [];
    this.modifiers = [];

    loadSizeModifiers.call(this);

    // Load modifier groups
    modifier_groups.each(group => {
        const modifier_group = OrderModifierGroup(group, this);
        // Modifier group may not contain any modifier as they are all duplicates
        if (!modifier_group.modifiers) {
            return;
        }
        this.modifier_groups.push(modifier_group);

        if (group.type === 'hidden') {
            this.hidden_modifier_groups.push(modifier_group);
        } else {
            this.visible_modifier_groups.push(modifier_group);
        }
    });
}

function loadSizeModifiers() {
    const { menu_product } = this;
    const size_modifier_group = menu_product.getSizeModifierGroup();
    const SizeModifier = Mobi2Go._class.OrderProductSizeModifier;

    this.size_options = [];

    // Load size modifiers
    if (size_modifier_group) {
        this.size_options = size_modifier_group.getModifiers().map(group => {
            return SizeModifier(group, this);
        });
        if (this.size_options) {
            this.setSize(
                this.size_options.filter(
                    ({ visible, out_of_stock }) => visible && !out_of_stock
                )[0]
            );
        }
    } else {
        this.setSize(null);
    }

    this.updateAvailableSizeOptions();
}
